import React from 'react'
import { Pie } from 'react-chartjs-2';

const PengunjungTerbanyak = ({ chartDataPengunjungTerbanyak }) => {
  return (
    <div className='chart-container'>
        <Pie
        data={chartDataPengunjungTerbanyak}
        options={{ 
            plugins: {
                title: {
                    display: true,
                }
            }
         }}/>
    </div>
  )
}

export default PengunjungTerbanyak